import Image from 'next/image';

import { Typography } from '../../../../../design-system/components/typography/Typography';
import { HeaderBlockWithPictureSliceType } from '../../../../../domains/Prismic/BrandPages/BrandPagesDocument';

import style from './HeaderBlockWithPictureSlice.module.css';

export type HeaderBlockWithPictureSliceProps = HeaderBlockWithPictureSliceType;

export function HeaderBlockWithPictureSlice({
    title,
    subtitle,
    picture,
}: HeaderBlockWithPictureSliceProps) {
    return (
        <div className={style.wrapper}>
            {picture?.url ? (
                <picture>
                    <source media="(min-width: 768px)" srcSet={picture.desktop.url} />
                    <Image
                        className={style.picture}
                        alt={picture.alt}
                        src={picture.url}
                        fill
                        priority
                        sizes={`(min-width: 768px) ${picture.width / 2}px, ${picture.desktop.width / 2}px`}
                    />
                </picture>
            ) : null}
            <div className={style.content}>
                {subtitle ? (
                    <Typography as="div" scale="primary-m-extra-bold" className={style.subtitle}>
                        {subtitle?.toUpperCase()}
                    </Typography>
                ) : null}
                <Typography as="h1" scale="secondary-xxl-bold" className={style.title}>
                    {title}
                </Typography>
            </div>
        </div>
    );
}
